import { adminApi } from "@/api/adminClient";

export const fetchAdminSubmissions = async (status = "pending") => {
  const res = await adminApi.get("/admin/submissions", { params: { status } });
  return res.data;
};

export const fetchAdminSubmissionDetail = async (id) => {
  const res = await adminApi.get(`/admin/submissions/${id}`);
  return res.data;
};

export const approveSubmission = async (id) => {
  const res = await adminApi.post(`/admin/submissions/${id}/approve`);
  return res.data;
};

export const rejectSubmission = async (id, reason = "") => {
  const res = await adminApi.post(`/admin/submissions/${id}/reject`, { reason });
  return res.data;
};

export const STATUS_META = {
  pending: {
    label: "In behandeling",
    color: "#F3C300",
    textColor: "#173A5E",
  },
  approved: {
    label: "Goedgekeurd",
    color: "#22a56b",
    textColor: "#FFFFFF",
  },
  rejected: {
    label: "Afgewezen",
    color: "#CE1B2A",
    textColor: "#FFFFFF",
  },
};

export const TYPE_LABEL = {
  nieuw: "Nieuwe aanmelding",
  aanvulling: "Profiel aanvullen",
};
